import { buildUrl } from '../../utils';
import { get } from '..';

export type Logout = () => Promise<void>;

export const fetchAuthenticated = () => get(buildUrl('/authenticated'));

export const logout: Logout = async () => get(buildUrl('/logout'));
